

export const merchantLogsActions = self => ({
  set(key, value) {
    self[key] = value
  }
})